import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin-used-cars"
export default class extends Controller {
  static targets = [
    "checkbox", "approveButton", "rejectButton", "selectAll",
    "bulkModal", "singleModal"
  ]

  connect() {
    this.updateButtonStates()
  }

  updateButtonStates() {
    const anyChecked = this.checkboxTargets.some(checkbox => checkbox.checked)

    if (this.hasApproveButtonTarget) {
      this.approveButtonTarget.disabled = !anyChecked
    }

    if (this.hasRejectButtonTarget) {
      this.rejectButtonTarget.disabled = !anyChecked
    }
  }

  toggleAllCheckboxes() {
    const isChecked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateButtonStates()
  }

  prepareBulkRejectModal(event) {
    if (event) event.preventDefault()

    if (!this.hasBulkModalTarget) return
    
    const modalCtrl = this.application.getControllerForElementAndIdentifier(this.bulkModalTarget, "modal")
    if (!modalCtrl || !modalCtrl.dialogElement) return

    const form = modalCtrl.dialogElement.querySelector('form')
    if (!form) return
    
    form.querySelectorAll('input[name="used_car_ids[]"]').forEach(el => el.remove())
    
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.checked) {
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = "used_car_ids[]"
        input.value = checkbox.value
        form.appendChild(input)
      }
    })

    this.bulkModalTarget.dispatchEvent(new Event('open', { bubbles: true }))
  }

  prepareSingleRejectModal(event) {
    if (event) event.preventDefault()

    const button = event.currentTarget
    const url = button.dataset.url

    if (!this.hasSingleModalTarget) return    

    const modalCtrl = this.application.getControllerForElementAndIdentifier(this.singleModalTarget, "modal")
    if (!modalCtrl || !modalCtrl.dialogElement) return

    const form = modalCtrl.dialogElement.querySelector('form')
    
    if (form) {
      form.action = url
    }

    this.singleModalTarget.dispatchEvent(new Event('open', { bubbles: true }))
  }
}
